import { IAlertSubscriptionStoreSegment } from './alertSubscription.interface';

export const alertSubscriptionStoreSelector = (state: IAlertSubscriptionStoreSegment) => state.alertSubscription;
